import { jsx as _jsx } from "react/jsx-runtime";
import WarningRounded from '@mui/icons-material/WarningRounded';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AlertMessage } from './AlertMessage.js';
export const MinFromAmountUSDMessage = ({ minFromAmountUSD, ...props }) => {
    const { t } = useTranslation();
    return (_jsx(AlertMessage, { severity: "warning", icon: _jsx(WarningRounded, {}), title: _jsx(Typography, { variant: "body2", sx: {
                color: 'text.primary',
            }, children: t('warning.message.minFromAmountUSD', {
                amount: minFromAmountUSD,
                minimumFractionDigits: 0,
            }) }), multiline: true, ...props }));
};
//# sourceMappingURL=MinFromAmountUSDMessage.js.map